import { prixClientCatalogue } from './prixCatalogueMihi';
import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import { C } from './constants';
import { UploadPhoto, UploadVideo } from './FormationProduitsTab';
import { DecouverteTour } from './App';
import { TokensCadeauxTab } from './TokensCadeauxTab';
import { BlocPaiementsAlternatifs } from './PaiementsAlternatifs';

export const THEMES_LINKBIO=[
  {id:"elegance",label:"Élégance",bg:"linear-gradient(135deg,#3D1F0E,#5C3020)",header:"linear-gradient(135deg,#3D1F0E,#5C3020)",accent:"#C4A882",text:"white",btnPrimary:"#C49A8A",btnSecondary:"white",btnTertiary:"#3D1F0E",cardBg:"white",preview:"🤎"},
  {id:"rose_gold",label:"Rose Gold",bg:"linear-gradient(135deg,#F9E5E0,#F2C4BB)",header:"linear-gradient(135deg,#C49A8A,#A0716A)",accent:"#C49A8A",text:"white",btnPrimary:"#C49A8A",btnSecondary:"white",btnTertiary:"#5C3020",cardBg:"#FFF5F3",preview:"🌸"},
  {id:"nuit",label:"Nuit Étoilée",bg:"linear-gradient(135deg,#0D0D2B,#1A1A4E)",header:"linear-gradient(135deg,#0D0D2B,#1A1A4E)",accent:"#A89BB5",text:"white",btnPrimary:"#A89BB5",btnSecondary:"rgba(255,255,255,.9)",btnTertiary:"#0D0D2B",cardBg:"#12122E",preview:"🌙"},
  {id:"or_noir",label:"Or & Noir",bg:"#0A0A0A",header:"linear-gradient(135deg,#1A1A1A,#2D2D2D)",accent:"#C4A832",text:"white",btnPrimary:"#C4A832",btnSecondary:"white",btnTertiary:"#1A1A1A",cardBg:"#141414",preview:"⚫"},
  {id:"nature",label:"Nature & Vert",bg:"linear-gradient(135deg,#E8F5E9,#C8E6C9)",header:"linear-gradient(135deg,#2E7D32,#388E3C)",accent:"#2E7D32",text:"white",btnPrimary:"#4CAF50",btnSecondary:"white",btnTertiary:"#1B5E20",cardBg:"white",preview:"🌿"},
  {id:"lavande",label:"Lavande",bg:"linear-gradient(135deg,#EDE7F6,#D1C4E9)",header:"linear-gradient(135deg,#7E57C2,#9575CD)",accent:"#7E57C2",text:"white",btnPrimary:"#9575CD",btnSecondary:"white",btnTertiary:"#4527A0",cardBg:"white",preview:"💜"},
  {id:"soleil",label:"Soleil d'Été",bg:"linear-gradient(135deg,#FFF8E1,#FFF3CD)",header:"linear-gradient(135deg,#F57F17,#F9A825)",accent:"#F57F17",text:"white",btnPrimary:"#FF8F00",btnSecondary:"white",btnTertiary:"#E65100",cardBg:"white",preview:"☀️"},
  {id:"ocean",label:"Océan",bg:"linear-gradient(135deg,#E3F2FD,#BBDEFB)",header:"linear-gradient(135deg,#1565C0,#1976D2)",accent:"#1565C0",text:"white",btnPrimary:"#1976D2",btnSecondary:"white",btnTertiary:"#0D47A1",cardBg:"white",preview:"🌊"},
  {id:"corail",label:"Corail & Blanc",bg:"#FFF9F7",header:"linear-gradient(135deg,#FF6B6B,#FF8E8E)",accent:"#FF6B6B",text:"white",btnPrimary:"#FF6B6B",btnSecondary:"white",btnTertiary:"#C62828",cardBg:"white",preview:"🪸"},
  {id:"minimaliste",label:"Minimaliste",bg:"#FAFAFA",header:"linear-gradient(135deg,#212121,#424242)",accent:"#212121",text:"white",btnPrimary:"#212121",btnSecondary:"white",btnTertiary:"#000",cardBg:"white",preview:"⬛"},
];

// Recherche de produit : sans accents, sans majuscules, mots dans n'importe quel ordre (« colon detox » trouve « Detox Colon »)
const normRecherche=(t)=>String(t||"").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"");
const correspondRecherche=(nom,q)=>{const mots=normRecherche(q).split(/\s+/).filter(Boolean);if(!mots.length)return true;const n=normRecherche(nom);return mots.every(m=>n.includes(m));};

function LinkBioTab({uid, userName, initialSection="theme"}){
  const[profil,setProfil]=useState({
    prenom:"",slogan:"",histoire:"",photo:"",theme:"elegance",
    accroche:"",nbClientes:"",nbDiags:"",nbEquipe:"",nbAnnees:"",
    ctaLabel:"✨ Faire mon diagnostic gratuit",ctaUrl:"",
    urgence:"",banniere:"",banniereUrl:"",badge:"",
    lienBoutique:"",lienRecrutement:"",lienDiag:"",lienBoutiqueLabel:"",lienRecrutementLabel:"",
    liensBonusLabel:[],liensBonusUrl:[],liensBonusPhoto:[],
    photos:[],temoignages:[],produitsStar:[],faq:[],
    diagChoisis:["parfum","skincare","silhouette","sante"],
    showBanniere:true,
    bannierePersoBg:"",bannierePersoTexte:"",bannierePersoLien:"",bannierePersoActif:false,ebooksIds:[],
    parcoursPhotos:[],parcoursTexte1:"",parcoursTexte2:"",parcoursTexte3:"",parcoursProduits:[],
    reseauxFacebook:"",reseauxInstagram:"",reseauxTiktok:"",reseauxYoutube:"",
    boutiqueActive:false,boutiquePresentation:"",bestSellers:[],packsPersonnalises:[],livraisonGratuite:false,
  });
  const[banniereGlobale,setBanniereGlobale]=useState(null);
  const[saving,setSaving]=useState(false);
  const[saved,setSaved]=useState(false);
  const[loading,setLoading]=useState(true);
  const[copied,setCopied]=useState(false);
  const[activeSection,setActiveSection]=useState(initialSection); // theme|profil|liens|banniere|photos
  const[showDecouverte,setShowDecouverte]=useState(false);

  const slug=(userName||uid).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9]/g,"-");
  const bioUrl=`https://blazing-dinasty-1fad9.web.app?bio=${slug}`;
  const tunnelUrl=`https://blazing-dinasty-1fad9.web.app?tunnel=${slug}`;
  const boutiqueUrl=`https://blazing-dinasty-1fad9.web.app?boutique=${slug}`;
  const[tokensOuvert,setTokensOuvert]=useState(false);
  const [catalogueProduits,setCatalogueProduits]=useState(null);
  const [filtreBestSellers,setFiltreBestSellers]=useState("");
  const [creationPack,setCreationPack]=useState(false);
  const [packNom,setPackNom]=useState("");
  const [packPrix,setPackPrix]=useState("");
  const [packProduits,setPackProduits]=useState([]);
  const [packEnPromo,setPackEnPromo]=useState(false);
  const [packPrixPromo,setPackPrixPromo]=useState("");
  const [packPhotos,setPackPhotos]=useState([]);
  const [filtrePack,setFiltrePack]=useState("");
  const [lienPaypalMe,setLienPaypalMe]=useState("");
  const [lienStripePerso,setLienStripePerso]=useState("");
  const [paiementSaving,setPaiementSaving]=useState(false);
  const [paiementSaved,setPaiementSaved]=useState(false);
  useEffect(()=>{
    if(activeSection!=="boutique")return;
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"users",uid));
        if(snap.exists()){
          setLienPaypalMe(snap.data()["db-lien-paypalme"]||"");
          setLienStripePerso(snap.data()["db-lien-stripe-perso"]||"");
        }
      }catch{}
    })();
  },[activeSection]);
  const sauverPaiementPerso=async()=>{
    setPaiementSaving(true);
    try{
      await setDoc(doc(db,"users",uid),{
        "db-lien-paypalme":lienPaypalMe.trim(),
        "db-lien-stripe-perso":lienStripePerso.trim()
      },{merge:true});
      await setDoc(doc(db,"contacts_publics",uid),{
        "db-lien-paypalme":lienPaypalMe.trim(),
        "db-lien-stripe-perso":lienStripePerso.trim()
      },{merge:true});
      setPaiementSaved(true);setTimeout(()=>setPaiementSaved(false),2000);
    }catch(e){alert("Erreur : "+e.message);}
    setPaiementSaving(false);
  };
  const [copiedBoutique,setCopiedBoutique]=useState(false);
  const copyBoutiqueUrl=()=>{navigator.clipboard?.writeText(boutiqueUrl);setCopiedBoutique(true);setTimeout(()=>setCopiedBoutique(false),2000);};
  useEffect(()=>{
    if(activeSection==="boutique"&&!catalogueProduits){
      getDoc(doc(db,"admin","catalogue_mihi")).then(snap=>{
        if(snap.exists())setCatalogueProduits(Object.values(prixClientCatalogue(snap.data())).flat());
      }).catch(()=>{});
    }
  },[activeSection]);

  const theme=THEMES_LINKBIO.find(t=>t.id===profil.theme)||THEMES_LINKBIO[0];

  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"linkbio",uid));
        if(snap.exists()) setProfil(p=>({...p,...snap.data()}));
      }catch{}
      try{
        const bSnap=await getDoc(doc(db,"admin","linkbio_banniere"));
        if(bSnap.exists()) setBanniereGlobale(bSnap.data());
      }catch{}
      setLoading(false);
    })();
  },[uid]);

  const save=async()=>{
    setSaving(true);
    try{
      await setDoc(doc(db,"linkbio",uid),{...profil,uid,slug,updatedAt:Date.now()});
      setSaved(true);setTimeout(()=>setSaved(false),2500);
    }catch{}
    setSaving(false);
  };

  const copyUrl=()=>{navigator.clipboard?.writeText(bioUrl);setCopied(true);setTimeout(()=>setCopied(false),2000);};

  const addLienBonus=()=>{
    setProfil(p=>({...p,
      liensBonusLabel:[...(p.liensBonusLabel||[]),""],
      liensBonusUrl:[...(p.liensBonusUrl||[]),""],
      liensBonusPhoto:[...(p.liensBonusPhoto||[]),""],
    }));
  };
  const removeLienBonus=(i)=>{
    setProfil(p=>({...p,
      liensBonusLabel:(p.liensBonusLabel||[]).filter((_,j)=>j!==i),
      liensBonusUrl:(p.liensBonusUrl||[]).filter((_,j)=>j!==i),
      liensBonusPhoto:(p.liensBonusPhoto||[]).filter((_,j)=>j!==i),
    }));
  };

  const addParcoursProduit=()=>{setProfil(p=>{const arr=p.parcoursProduits||[];if(arr.length>=10)return p;return {...p,parcoursProduits:[...arr,{nom:"",photo:"",videoUrl:"",texte:""}]};});};
  const removeParcoursProduit=(i)=>{setProfil(p=>({...p,parcoursProduits:(p.parcoursProduits||[]).filter((_,j)=>j!==i)}));};
  if(loading)return null;

  const SECTIONS=[
    {id:"theme",icon:"🎨",label:"Thème"},
    {id:"profil",icon:"✨",label:"Profil"},
    {id:"liens",icon:"🔗",label:"Liens"},
    {id:"photos",icon:"💬",label:"Retours clients"},{id:"parcours",icon:"🌟",label:"Mon Parcours"},{id:"reseaux",icon:"📱",label:"Reseaux"},
    {id:"ebooks",icon:"📚",label:"Ebooks"},{id:"banniere",icon:"📢",label:"Bannière"},{id:"boutique",icon:"🛍️",label:"Boutique"},
    {id:"stats",icon:"📊",label:"Stats"},
  ];

  // Prévisualisation
  const Preview=({bg=banniereGlobale})=>(
    <div style={{background:theme.bg,borderRadius:14,overflow:"hidden",maxWidth:300,margin:"0 auto",boxShadow:"0 4px 24px rgba(0,0,0,.12)"}}>
      {/* Bannière */}
      {((bg?.actif&&bg?.texte&&profil.showBanniere)||(profil.bannierePersoActif&&profil.bannierePersoTexte))&&(
        <div style={{background:profil.bannierePersoBg||(profil.bannierePersoActif&&profil.bannierePersoTexte?undefined:bg?.couleur)||theme.btnPrimary,padding:".5rem .75rem",textAlign:"center",fontSize:".7rem",fontWeight:600,color:"white",whiteSpace:"pre-line"}}>
          {profil.bannierePersoActif&&profil.bannierePersoTexte ? profil.bannierePersoTexte : bg?.texte}
        </div>
      )}

      {/* Header */}
      <div style={{background:theme.header,padding:"1.5rem 1rem",textAlign:"center"}}>
        {profil.photo
          ?<img src={profil.photo} alt="" style={{width:72,height:72,borderRadius:"50%",objectFit:"cover",border:"3px solid rgba(255,255,255,.25)",marginBottom:".6rem",display:"block",margin:"0 auto .6rem"}}/>
          :<div style={{width:72,height:72,borderRadius:"50%",background:"rgba(255,255,255,.2)",margin:"0 auto .6rem",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.8rem",fontFamily:"Georgia,serif",color:"white",fontWeight:600}}>
            {(profil.prenom||userName||"B")[0].toUpperCase()}
          </div>
        }
        <div style={{fontFamily:"Georgia,serif",fontSize:"1.05rem",fontWeight:600,color:theme.text}}>{profil.prenom||userName}</div>
        {profil.slogan&&<div style={{fontSize:".65rem",color:"rgba(255,255,255,.75)",marginTop:".2rem",lineHeight:1.5}}>{profil.slogan}</div>}
      </div>

      {profil.histoire&&<div style={{padding:".75rem 1rem",fontSize:".72rem",lineHeight:1.65,color:theme.id==="nuit"||theme.id==="or_noir"?"rgba(255,255,255,.75)":C.gris,background:theme.cardBg}}>{profil.histoire}</div>}

      {/* Photos */}
      {(profil.photos||[]).filter(p=>p).length>0&&(
        <div style={{display:"flex",gap:".3rem",padding:".5rem .75rem",overflowX:"auto",background:theme.cardBg}}>
          {profil.photos.filter(p=>p).map((url,i)=>(
            <img key={i} src={url} alt="" style={{width:68,height:68,borderRadius:8,objectFit:"cover",flexShrink:0}}/>
          ))}
        </div>
      )}

      {/* Liens */}
      <div style={{padding:"0 .75rem",display:"flex",flexDirection:"column",gap:".4rem"}}>
        {(profil.liensBonusLabel||[]).map((lbl,i)=>lbl&&profil.liensBonusUrl?.[i]&&(
          <a key={i} href={profil.liensBonusUrl[i]} target="_blank" rel="noopener noreferrer" style={{display:"flex",alignItems:"center",gap:".5rem",background:theme.accent+"15",border:`1.5px solid ${theme.accent}30`,borderRadius:10,padding:".45rem .75rem",textDecoration:"none"}}>
            {profil.liensBonusPhoto?.[i]&&<img src={profil.liensBonusPhoto[i]} alt="" style={{width:30,height:30,borderRadius:6,objectFit:"cover",flexShrink:0}}/>}
            <span style={{fontSize:".75rem",fontWeight:600,color:theme.accent}}>{lbl}</span>
          </a>
        ))}
      </div>
      <div style={{padding:".4rem",textAlign:"center",fontSize:".55rem",color:theme.accent,background:theme.cardBg}}>Blazing Dynasty × Mihi</div>
    </div>
  );

  return(
    <div>
      <div style={{fontFamily:"Georgia,serif",fontSize:"1.35rem",fontWeight:300,color:C.brun,marginBottom:".2rem"}}>
       {activeSection==="boutique"?"Ma ":"Mon "}<em style={{fontStyle:"italic",color:C.rose}}>{activeSection==="boutique"?"Boutique":"Link-in-Bio"}</em>
      </div>

      {/* Lien à copier */}
      {(()=>{ const estBoutique = activeSection==="boutique"; return (<>
      <div style={{background:`linear-gradient(135deg,${C.brun},${C.brun2})`,borderRadius:12,padding:".85rem 1rem",marginBottom:"1rem",display:"flex",alignItems:"center",gap:".75rem"}}>
        <div style={{flex:1}}>
          <div style={{fontSize:".55rem",fontWeight:700,letterSpacing:".1em",color:C.or,textTransform:"uppercase",marginBottom:".2rem"}}>🔗 {estBoutique?"Ton lien boutique":"Ton lien de bio"}</div>
          <div style={{fontSize:".68rem",color:C.pale,wordBreak:"break-all"}}>{estBoutique?boutiqueUrl:bioUrl}</div>
        </div>
        <button onClick={estBoutique?copyBoutiqueUrl:copyUrl} style={{background:C.or,color:C.brun,border:"none",borderRadius:8,padding:".38rem .7rem",fontSize:".7rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",flexShrink:0}}>
          {(estBoutique?copiedBoutique:copied)?"✓ Copié!":"📋 Copier"}
        </button>
      </div>
      </>); })()}

      <div style={{display:"flex",justifyContent:"flex-end",marginBottom:".5rem"}}><button onClick={()=>setShowDecouverte(true)} style={{background:"#C49A8A",color:"white",border:"none",borderRadius:20,padding:".35rem 1rem",fontSize:".75rem",fontWeight:700,cursor:"pointer",fontFamily:"inherit",boxShadow:"0 2px 8px rgba(196,154,138,.4)"}}>🧭 Découverte</button></div>
      {showDecouverte&&<DecouverteTour outil="linkbio" onClose={()=>setShowDecouverte(false)} onStepChange={sec=>{if(sec)setActiveSection(sec);}}/>}
      {/* Navigation sections */}
      <div style={{display:"flex",gap:".3rem",marginBottom:"1rem",overflowX:"auto",paddingBottom:".2rem"}}>
        {SECTIONS.map(s=>(
          <button key={s.id} onClick={()=>setActiveSection(s.id)}
            style={{flexShrink:0,padding:".38rem .65rem",fontSize:".68rem",fontWeight:600,borderRadius:9,border:`1.5px solid ${activeSection===s.id?C.rose:C.pale}`,background:activeSection===s.id?C.rose:C.blanc,color:activeSection===s.id?"white":C.gris,cursor:"pointer",fontFamily:"inherit",whiteSpace:"nowrap"}}>
            {s.icon} {s.label}
          </button>
        ))}
      </div>

      {/* SECTION THÈME */}
      {activeSection==="theme"&&(
        <div>
          <div style={{fontSize:".6rem",fontWeight:700,color:C.gris,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".6rem"}}>Choisis ton thème</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:".4rem",marginBottom:"1rem"}}>
            {THEMES_LINKBIO.map(t=>(
              <div key={t.id} onClick={()=>setProfil(p=>({...p,theme:t.id}))}
                style={{textAlign:"center",cursor:"pointer",padding:".4rem .2rem",borderRadius:10,border:`2px solid ${profil.theme===t.id?C.rose:C.pale}`,background:profil.theme===t.id?C.rose+"10":"transparent",transition:"all .15s"}}>
                <div style={{fontSize:"1.4rem"}}>{t.preview}</div>
                <div style={{fontSize:".55rem",fontWeight:600,color:profil.theme===t.id?C.rose:C.gris,marginTop:".2rem",lineHeight:1.2}}>{t.label}</div>
              </div>
            ))}
          </div>
          <Preview/>
        </div>
      )}

      {/* SECTION PROFIL */}
      {activeSection==="profil"&&(
        <div>
          <div style={{fontSize:".6rem",fontWeight:700,color:C.gris,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".6rem"}}>Ton profil</div>
          {[
            {label:"Prénom affiché",key:"prenom",placeholder:"Ex: Melissa"},
            {label:"Phrase d'accroche",key:"slogan",placeholder:"Ex: Maman entrepreneur 🌸"},
          ].map(f=>(
            <div key={f.key} style={{marginBottom:".6rem"}}>
              <div style={{fontSize:".6rem",color:C.gris,marginBottom:".2rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>{f.label}</div>
              <input value={profil[f.key]||""} onChange={e=>setProfil(p=>({...p,[f.key]:e.target.value}))}
                style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
            </div>
          ))}
          <UploadPhoto label="Photo de profil" value={profil.photo} onChange={v=>setProfil(p=>({...p,photo:v}))} folder="linkbio"/>
          <div style={{marginBottom:".6rem"}}>
            <div style={{fontSize:".6rem",color:C.gris,marginBottom:".2rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>Mon histoire</div>
            <textarea value={profil.histoire||""} onChange={e=>setProfil(p=>({...p,histoire:e.target.value}))} placeholder="2-3 phrases : qui tu es, pourquoi Mihi..." rows={3}
              style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",resize:"vertical",lineHeight:1.55}}/>
          </div>

          {/* Accroche forte */}
          <div style={{marginBottom:".6rem"}}>
            <div style={{fontSize:".6rem",color:C.gris,marginBottom:".2rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>💬 Citation / Accroche forte</div>
            <input value={profil.accroche||""} onChange={e=>setProfil(p=>({...p,accroche:e.target.value}))} placeholder="Ex: J'ai retrouvé confiance en moi grâce à Mihi"
              style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
          </div>

          {/* Stats chiffrées */}
          <div style={{fontSize:".6rem",color:C.gris,marginBottom:".3rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>📊 Chiffres clés (social proof)</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".35rem",marginBottom:".6rem"}}>
            {[
              {key:"nbClientes",placeholder:"Ex: 48 clientes"},
              {key:"nbDiags",placeholder:"Ex: 120 diags"},
              {key:"nbEquipe",placeholder:"Ex: 12 dans l'équipe"},
              {key:"nbAnnees",placeholder:"Ex: 2 ans d'exp."},
            ].map(f=>(
              <input key={f.key} value={profil[f.key]||""} onChange={e=>setProfil(p=>({...p,[f.key]:e.target.value}))}
                style={{border:`1px solid ${C.pale}`,borderRadius:7,padding:".35rem .5rem",fontSize:".72rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
            ))}
          </div>

          {/* CTA Principal */}
          <div style={{fontSize:".6rem",color:C.rose,marginBottom:".3rem",fontWeight:700,textTransform:"uppercase",letterSpacing:".08em"}}>🎯 Bouton d'appel à l'action principal</div>
          <input value={profil.ctaLabel||""} onChange={e=>setProfil(p=>({...p,ctaLabel:e.target.value}))} placeholder="Ex: ✨ Faire mon diagnostic gratuit"
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".35rem"}}/>
          <input value={profil.ctaUrl||""} onChange={e=>setProfil(p=>({...p,ctaUrl:e.target.value}))} placeholder="URL du CTA (lien diagnostic par défaut)"
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".6rem"}}/>

          {/* Urgence */}
          <div style={{fontSize:".6rem",color:C.or,marginBottom:".2rem",fontWeight:700,textTransform:"uppercase",letterSpacing:".08em"}}>⏰ Message d'urgence (optionnel)</div>
          <input value={profil.urgence||""} onChange={e=>setProfil(p=>({...p,urgence:e.target.value}))} placeholder="Ex: Offre limitée — seulement 5 places cette semaine"
            style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".6rem"}}/>

            
          {/* ── Choix des diagnostics ── */}
          <div style={{marginBottom:".75rem",padding:".75rem",background:C.creme,borderRadius:10,border:`1px solid ${C.pale}`}}>
            <div style={{fontSize:".6rem",color:C.gris,marginBottom:".5rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>🩺 Diagnostics affichés sur ton LinkBio</div>
            {[
              {id:"parfum",label:"🌸 Diagnostic Parfum"},
              {id:"skincare",label:"✨ Diagnostic Skincare"},
              {id:"silhouette",label:"⚖️ Diagnostic Silhouette"},
              {id:"sante",label:"💚 Diagnostic Bien-être"},
              {id:"cheveux",label:"💇 Diagnostic Cheveux"},
              {id:"makeup",label:"💄 Diagnostic Makeup"},
              {id:"recrutement",label:"👑 Diagnostic Opportunité"},
              {id:"blocage",label:"👩‍👧 Diagnostic Maman Entrepreneur"},
            ].map(d=>{
              const checked=(profil.diagChoisis||["parfum","skincare","silhouette","sante"]).includes(d.id);
              return(<label key={d.id} style={{display:"flex",alignItems:"center",gap:".5rem",padding:".3rem 0",cursor:"pointer",fontSize:".78rem",color:C.texte}}>
                <input type="checkbox" checked={checked} onChange={()=>{
                  const current=profil.diagChoisis||["parfum","skincare","silhouette","sante"];
                  const next=checked?current.filter(x=>x!==d.id):[...current,d.id];
                  setProfil(p=>({...p,diagChoisis:next}));
                }} style={{accentColor:C.rose,width:15,height:15}}/>
                {d.label}
              </label>);
            })}
          </div>



          <Preview/>
        </div>
      )}

      {/* SECTION LIENS */}
      {activeSection==="liens"&&(
        <div>
          <div style={{fontSize:".6rem",fontWeight:700,color:C.gris,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".6rem"}}>Liens principaux</div>
          {[
            {labelKey:"lienBoutiqueLabel",labelDefault:"🛍️ Boutique Mihi",key:"lienBoutique",placeholder:"https://mihi.care/fr/..."},
            {labelKey:"lienRecrutementLabel",labelDefault:"👑 Rejoindre l'équipe",key:"lienRecrutement",placeholder:"https://mihi.care/fr/..."},
          ].map(f=>(
            <div key={f.key} style={{marginBottom:".75rem"}}>
              <div style={{fontSize:".6rem",color:C.gris,marginBottom:".2rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>Intitulé du bouton</div>
              <input value={profil[f.labelKey]||""} onChange={e=>setProfil(p=>({...p,[f.labelKey]:e.target.value}))} placeholder={f.labelDefault}
                style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".38rem .65rem",fontSize:".75rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".25rem"}}/>
              <div style={{fontSize:".6rem",color:C.gris,marginBottom:".2rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>URL</div>
              <input value={profil[f.key]||""} onChange={e=>setProfil(p=>({...p,[f.key]:e.target.value}))}
                style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
            </div>
          ))}
          <div style={{display:"flex",alignItems:"center",gap:".5rem",background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:10,padding:".65rem .8rem",marginTop:".5rem"}}>
            <div onClick={()=>setProfil(p=>({...p,catalogueActif:!p.catalogueActif}))}
              style={{width:20,height:20,borderRadius:5,border:`2px solid ${C.rose}`,background:profil.catalogueActif?C.rose:"transparent",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              {profil.catalogueActif&&<span style={{fontSize:".6rem",color:"white",fontWeight:700}}>OK</span>}
            </div>
            <div style={{fontSize:".72rem",color:C.texte,cursor:"pointer"}} onClick={()=>setProfil(p=>({...p,catalogueActif:!p.catalogueActif}))}>
              Afficher le bouton catalogue produits sur ma page
            </div>
          </div>

          {/* Liens bonus */}
          <div style={{height:1,background:C.pale,margin:"1rem 0"}}/>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:".6rem"}}>
            <div style={{fontSize:".6rem",fontWeight:700,color:C.gris,letterSpacing:".1em",textTransform:"uppercase"}}>Liens bonus</div>
            <button onClick={addLienBonus} style={{background:C.brun,color:C.blanc,border:"none",borderRadius:7,padding:".25rem .6rem",fontSize:".68rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>+ Ajouter</button>
          </div>
          {(profil.liensBonusLabel||[]).map((_,i)=>(
            <div key={i} style={{background:C.creme,borderRadius:9,padding:".65rem",marginBottom:".5rem",border:`1px solid ${C.pale}`}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:".35rem"}}>
                <div style={{fontSize:".62rem",fontWeight:700,color:C.gris}}>Lien bonus {i+1}</div>
                <button onClick={()=>removeLienBonus(i)} style={{background:"none",border:"none",color:C.gris,cursor:"pointer",fontSize:".7rem"}}>✕</button>
              </div>
              <input value={profil.liensBonusLabel?.[i]||""} onChange={e=>{const a=[...(profil.liensBonusLabel||[])];a[i]=e.target.value;setProfil(p=>({...p,liensBonusLabel:a}));}}
                placeholder="Label du bouton" style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:7,padding:".38rem .55rem",fontSize:".76rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none",marginBottom:".3rem"}}/>
              <input value={profil.liensBonusUrl?.[i]||""} onChange={e=>{const a=[...(profil.liensBonusUrl||[])];a[i]=e.target.value;setProfil(p=>({...p,liensBonusUrl:a}));}}
                placeholder="URL https://..." style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:7,padding:".38rem .55rem",fontSize:".76rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none",marginBottom:".3rem"}}/>
              <input value={profil.liensBonusPhoto?.[i]||""} onChange={e=>{const a=[...(profil.liensBonusPhoto||[])];a[i]=e.target.value;setProfil(p=>({...p,liensBonusPhoto:a}));}}
                placeholder="Photo miniature (URL optionnel)" style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:7,padding:".38rem .55rem",fontSize:".76rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none"}}/>
            </div>
          ))}
        </div>
      )}

      {/* SECTION PHOTOS */}
      {activeSection==="photos"&&(
        <div>
          <div style={{fontSize:".6rem",fontWeight:700,color:C.gris,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".4rem"}}>Retours clients</div>
          <p style={{fontSize:".7rem",color:C.gris,lineHeight:1.6,marginBottom:".75rem"}}>Partage les avis et messages de tes clientes satisfaites pour rassurer tes visiteuses.</p>
          <div style={{fontSize:".6rem",color:C.gris,fontWeight:700,textTransform:"uppercase",letterSpacing:".08em"}}>💬 Témoignages clientes</div>
            <button onClick={()=>setProfil(p=>({...p,temoignages:[...(p.temoignages||[]),{texte:"",auteur:""}]}))}
              style={{background:C.brun,color:"white",border:"none",borderRadius:7,padding:".22rem .55rem",fontSize:".65rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer"}}>+ Ajouter</button>
          {(profil.temoignages||[]).map((t,i)=>(
            <div key={i} style={{background:C.creme,borderRadius:9,padding:".55rem",marginBottom:".35rem",border:`1px solid ${C.pale}`}}>
              <UploadPhoto label="Capture d'écran (optionnel)" value={t.photo||""} onChange={v=>{const a=[...(profil.temoignages||[])];a[i]={...a[i],photo:v};setProfil(p=>({...p,temoignages:a}));}}/>
              <textarea value={t.texte} onChange={e=>{const a=[...(profil.temoignages||[])];a[i]={...a[i],texte:e.target.value};setProfil(p=>({...p,temoignages:a}));}}
                placeholder="Texte du témoignage" rows={2}
                style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:7,padding:".3rem .5rem",fontSize:".72rem",fontFamily:"inherit",color:C.texte,background:"white",outline:"none",resize:"none",marginBottom:".3rem"}}/>
              <div style={{display:"flex",gap:".3rem"}}>
                <input value={t.auteur} onChange={e=>{const a=[...(profil.temoignages||[])];a[i]={...a[i],auteur:e.target.value};setProfil(p=>({...p,temoignages:a}));}}
                  placeholder="Prénom de la cliente" style={{flex:1,border:`1px solid ${C.pale}`,borderRadius:7,padding:".28rem .5rem",fontSize:".7rem",fontFamily:"inherit",color:C.texte,background:"white",outline:"none"}}/>
                <button onClick={()=>setProfil(p=>({...p,temoignages:(p.temoignages||[]).filter((_,j)=>j!==i)}))}
                  style={{background:"none",border:"none",color:C.gris,cursor:"pointer",fontSize:".75rem"}}>✕</button>
              </div>
            </div>
          ))}
          {(profil.temoignages||[]).some(t=>t.texte)&&<Preview/>}
        </div>
      )}

      {activeSection==="parcours"&&(
        <div>
          <div style={{fontSize:".6rem",fontWeight:700,color:C.gris,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".4rem"}}>Mon Parcours</div>
          <p style={{fontSize:".7rem",color:C.gris,lineHeight:1.6,marginBottom:".75rem"}}>Raconte ton histoire : photos, storytelling, et tes produits phares du quotidien.</p>
          <div style={{fontSize:".62rem",fontWeight:700,color:C.rose,letterSpacing:".08em",textTransform:"uppercase",marginBottom:".4rem",marginTop:"1rem"}}>Photos</div>
          {(profil.parcoursPhotos||[]).map((ph,i)=>(
            <div key={i} style={{marginBottom:".5rem"}}>
              <UploadPhoto label={"Photo "+(i+1)} value={ph} onChange={v=>{const a=[...(profil.parcoursPhotos||[])];a[i]=v;setProfil(p=>({...p,parcoursPhotos:a}));}}/>
              <button onClick={()=>{const a=(profil.parcoursPhotos||[]).filter((_,j)=>j!==i);setProfil(p=>({...p,parcoursPhotos:a}));}} style={{background:"none",border:"1px solid "+C.pale,borderRadius:7,padding:".22rem .5rem",fontSize:".65rem",color:C.gris,cursor:"pointer",fontFamily:"inherit"}}>Retirer cette photo</button>
            </div>
          ))}
          <button onClick={()=>setProfil(p=>({...p,parcoursPhotos:[...(p.parcoursPhotos||[]),""]}))} style={{background:C.brun,color:"white",border:"none",borderRadius:8,padding:".45rem .9rem",fontSize:".75rem",fontWeight:600,cursor:"pointer",fontFamily:"inherit",marginBottom:"1rem"}}>+ Ajouter une photo</button>
          <div style={{fontSize:".62rem",fontWeight:700,color:C.rose,letterSpacing:".08em",textTransform:"uppercase",marginBottom:".4rem",marginTop:"1rem"}}>Mon histoire</div>
          <textarea value={profil.parcoursTexte1||""} onChange={e=>setProfil(p=>({...p,parcoursTexte1:e.target.value}))} placeholder="Qui es-tu ? D'ou viens-tu ?" rows={4} style={{width:"100%",border:"1px solid "+C.pale,borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",resize:"vertical",marginBottom:".5rem"}}/>
          <textarea value={profil.parcoursTexte2||""} onChange={e=>setProfil(p=>({...p,parcoursTexte2:e.target.value}))} placeholder="Qu'est-ce qui a change pour toi ?" rows={4} style={{width:"100%",border:"1px solid "+C.pale,borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",resize:"vertical",marginBottom:".5rem"}}/>
          <textarea value={profil.parcoursTexte3||""} onChange={e=>setProfil(p=>({...p,parcoursTexte3:e.target.value}))} placeholder="Pourquoi tu fais ce que tu fais aujourd'hui ?" rows={4} style={{width:"100%",border:"1px solid "+C.pale,borderRadius:8,padding:".5rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",resize:"vertical",marginBottom:"1rem"}}/>
          <div style={{fontSize:".62rem",fontWeight:700,color:C.rose,letterSpacing:".08em",textTransform:"uppercase",marginBottom:".4rem",marginTop:"1rem"}}>{"Ce que j'utilise au quotidien ("+(profil.parcoursProduits||[]).length+"/10)"}</div>
          {(profil.parcoursProduits||[]).map((prod,i)=>(
            <div key={i} style={{background:C.blanc,border:"1px solid "+C.pale,borderRadius:10,padding:".75rem",marginBottom:".6rem"}}>
              <input value={prod.nom||""} onChange={e=>{const a=[...(profil.parcoursProduits||[])];a[i]={...a[i],nom:e.target.value};setProfil(p=>({...p,parcoursProduits:a}));}} placeholder="Nom du produit" style={{width:"100%",border:"1px solid "+C.pale,borderRadius:8,padding:".38rem .55rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".4rem"}}/>
              <UploadPhoto label="Photo du produit" value={prod.photo} onChange={v=>{const a=[...(profil.parcoursProduits||[])];a[i]={...a[i],photo:v};setProfil(p=>({...p,parcoursProduits:a}));}}/>
              <UploadVideo label="Video (optionnel)" value={prod.videoUrl} uid={uid} onChange={v=>{const a=[...(profil.parcoursProduits||[])];a[i]={...a[i],videoUrl:v};setProfil(p=>({...p,parcoursProduits:a}));}}/>
              <textarea value={prod.texte||""} onChange={e=>{const a=[...(profil.parcoursProduits||[])];a[i]={...a[i],texte:e.target.value};setProfil(p=>({...p,parcoursProduits:a}));}} placeholder="Pourquoi tu l'utilises, tes resultats..." rows={3} style={{width:"100%",border:"1px solid "+C.pale,borderRadius:8,padding:".42rem .6rem",fontSize:".76rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",resize:"vertical",marginTop:".4rem",marginBottom:".4rem"}}/>
              <button onClick={()=>removeParcoursProduit(i)} style={{background:"none",border:"1px solid "+C.pale,borderRadius:7,padding:".22rem .5rem",fontSize:".65rem",color:C.gris,cursor:"pointer",fontFamily:"inherit"}}>Retirer ce produit</button>
            </div>
          ))}
          {(profil.parcoursProduits||[]).length<10&&<button onClick={addParcoursProduit} style={{background:C.brun,color:"white",border:"none",borderRadius:8,padding:".45rem .9rem",fontSize:".75rem",fontWeight:600,cursor:"pointer",fontFamily:"inherit"}}>+ Ajouter un produit phare</button>}
        </div>
      )}
      {activeSection==="reseaux"&&(
        <div>
          <div style={{fontSize:".6rem",fontWeight:700,color:C.gris,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".4rem"}}>Reseaux sociaux</div>
          <p style={{fontSize:".7rem",color:C.gris,lineHeight:1.6,marginBottom:".75rem"}}>Ajoute tes liens. Ils s'afficheront tout en bas de ta page LinkBio.</p>
          <input value={profil.reseauxFacebook||""} onChange={e=>setProfil(p=>({...p,reseauxFacebook:e.target.value}))} placeholder="Lien Facebook" style={{width:"100%",border:"1px solid "+C.pale,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".4rem"}}/>
          <input value={profil.reseauxInstagram||""} onChange={e=>setProfil(p=>({...p,reseauxInstagram:e.target.value}))} placeholder="Lien Instagram" style={{width:"100%",border:"1px solid "+C.pale,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".4rem"}}/>
          <input value={profil.reseauxTiktok||""} onChange={e=>setProfil(p=>({...p,reseauxTiktok:e.target.value}))} placeholder="Lien TikTok" style={{width:"100%",border:"1px solid "+C.pale,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".4rem"}}/>
          <input value={profil.reseauxYoutube||""} onChange={e=>setProfil(p=>({...p,reseauxYoutube:e.target.value}))} placeholder="Lien YouTube" style={{width:"100%",border:"1px solid "+C.pale,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none"}}/>
        </div>
      )}
      {/* SECTION BANNIÈRE */}
      {activeSection==="stats"&&<StatsLinkBio uid={slug}/>}
      {activeSection==="ebooks"&&(<EbooksLinkBioSection profil={profil} setProfil={setProfil}/>)}{activeSection==="banniere"&&(
        <div>
          {/* Bannière globale admin */}
          {banniereGlobale?.actif&&banniereGlobale?.texte&&(
            <div style={{background:C.or+"15",border:`1px solid ${C.or}`,borderRadius:10,padding:".75rem",marginBottom:".85rem"}}>
              <div style={{fontSize:".6rem",fontWeight:700,color:C.or,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".3rem"}}>📢 Bannière équipe (de Melissa)</div>
              <div style={{fontSize:".78rem",color:C.brun,marginBottom:".5rem"}}>{banniereGlobale.texte}</div>
              <label style={{display:"flex",alignItems:"center",gap:".5rem",cursor:"pointer"}}>
                <input type="checkbox" checked={profil.showBanniere!==false} onChange={e=>setProfil(p=>({...p,showBanniere:e.target.checked}))}/>
                <span style={{fontSize:".74rem",color:C.brun,fontWeight:600}}>Afficher sur ma page</span>
              </label>
            </div>
          )}

          {/* Bannière personnelle */}
          <div style={{background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:"1rem"}}>
            <div style={{fontSize:".6rem",fontWeight:700,color:C.rose,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".6rem"}}>✨ Ma bannière personnelle</div>
            <input value={profil.bannierePersoTexte||""} onChange={e=>setProfil(p=>({...p,bannierePersoTexte:e.target.value}))} placeholder="Ex: Promo -15% ce weekend !" style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".4rem"}}/>


            <input value={profil.bannierePersoLien||""} onChange={e=>setProfil(p=>({...p,bannierePersoLien:e.target.value}))}
              placeholder="Lien optionnel (https://...)"
              style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".4rem"}}/>
            <div style={{display:"flex",gap:".75rem",alignItems:"center",marginBottom:".5rem"}}>
              <div style={{fontSize:".7rem",color:C.gris}}>Couleur :</div>
              <input type="color" value={profil.bannierePersoBg||"#C49A8A"} onChange={e=>setProfil(p=>({...p,bannierePersoBg:e.target.value}))}
                style={{width:36,height:30,border:"none",borderRadius:6,cursor:"pointer"}}/>
            </div>
            <label style={{display:"flex",alignItems:"center",gap:".5rem",cursor:"pointer"}}>
              <input type="checkbox" checked={!!profil.bannierePersoActif} onChange={e=>setProfil(p=>({...p,bannierePersoActif:e.target.checked}))}/>
              <span style={{fontSize:".74rem",color:C.brun,fontWeight:600}}>Activer ma bannière personnelle</span>
            </label>
          </div>

          {(profil.bannierePersoActif&&profil.bannierePersoTexte)||(banniereGlobale?.actif&&profil.showBanniere!==false)&&(
            <div style={{marginTop:"1rem"}}><Preview/></div>
          )}
        </div>
      )}

      {/* SECTION BOUTIQUE */}
      {activeSection==="boutique"&&(
        <div>
          <div style={{display:"flex",alignItems:"center",gap:".6rem",marginBottom:"1rem",padding:".75rem",background:C.creme,borderRadius:10,border:`1px solid ${C.pale}`}}>
            <div onClick={()=>setProfil(p=>({...p,boutiqueActive:!p.boutiqueActive}))}
              style={{width:20,height:20,borderRadius:5,border:`2px solid ${C.rose}`,background:profil.boutiqueActive?C.rose:"transparent",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              {profil.boutiqueActive&&<span style={{fontSize:".6rem",color:"white",fontWeight:700}}>OK</span>}
            </div>
            <div style={{fontSize:".72rem",color:C.texte,cursor:"pointer",fontWeight:600}} onClick={()=>setProfil(p=>({...p,boutiqueActive:!p.boutiqueActive}))}>
              Activer ma boutique en ligne (visible sur mon LinkBio)
            </div>
          </div>

          {profil.boutiqueActive&&(<>
            <div style={{background:"#F4F0FF",borderRadius:12,padding:"1rem",marginBottom:"1rem",border:"1px solid #D8CCFF"}}>
              <div style={{fontSize:".7rem",fontWeight:700,color:"#3D1F0E",marginBottom:".3rem"}}>💳 Encaisser tes ventes</div>
              <div style={{fontSize:".64rem",color:"#888",marginBottom:".7rem",lineHeight:1.5}}>
                Renseigne ton lien de paiement personnel — indépendant de la plateforme, c'est ton compte à toi, ton argent va directement chez toi.
              </div>
              <div style={{fontSize:".64rem",fontWeight:700,color:"#0070BA",marginBottom:".3rem"}}>🅿️ PayPal.me</div>
              <div style={{display:"flex",alignItems:"center",border:"1px solid #D8CCFF",borderRadius:8,marginBottom:".6rem",overflow:"hidden"}}>
                <span style={{padding:".42rem .5rem",fontSize:".76rem",color:"#888",background:"#F4F0FF",whiteSpace:"nowrap",fontFamily:"inherit"}}>paypal.me/</span>
                <input value={lienPaypalMe.replace(/^https?:\/\/(www\.)?paypal\.me\//i,"")} onChange={e=>setLienPaypalMe("https://paypal.me/"+e.target.value.replace(/^\/+/,""))} placeholder="tonpseudo"
                  style={{flex:1,border:"none",padding:".42rem .5rem",fontSize:".76rem",fontFamily:"inherit",outline:"none"}}/>
              </div>
              <div style={{fontSize:".64rem",fontWeight:700,color:"#635BFF",marginBottom:".3rem"}}>💳 Lien de paiement Stripe (optionnel)</div>
              <input value={lienStripePerso} onChange={e=>setLienStripePerso(e.target.value)} placeholder="https://buy.stripe.com/..."
                style={{width:"100%",border:"1px solid #D8CCFF",borderRadius:8,padding:".42rem .65rem",fontSize:".76rem",fontFamily:"inherit",marginBottom:".7rem",outline:"none"}}/>
              <button onClick={sauverPaiementPerso} disabled={paiementSaving}
                style={{width:"100%",background:paiementSaved?"#2E7D32":"#3D1F0E",color:"white",border:"none",borderRadius:8,padding:".5rem",fontSize:".76rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                {paiementSaving?"...":paiementSaved?"✅ Enregistré !":"Enregistrer mes liens de paiement"}
              </button>
            </div>
            <BlocPaiementsAlternatifs uid={uid}/>
            <div style={{display:"flex",alignItems:"center",gap:".6rem",background:C.creme,border:`1px solid ${C.pale}`,borderRadius:10,padding:".65rem .85rem",marginBottom:"1rem"}}>
              <div style={{flex:1}}>
                <div style={{fontSize:".55rem",fontWeight:700,letterSpacing:".1em",color:C.or,textTransform:"uppercase",marginBottom:".2rem"}}>🛍️ Lien de ma boutique</div>
                <div style={{fontSize:".68rem",color:C.pale,wordBreak:"break-all"}}>{boutiqueUrl}</div>
              </div>
              <button onClick={copyBoutiqueUrl} style={{background:C.or,color:C.brun,border:"none",borderRadius:8,padding:".38rem .7rem",fontSize:".7rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",flexShrink:0}}>
                {copiedBoutique?"✓ Copié!":"📋 Copier"}
              </button>
            </div>

            <div style={{marginBottom:"1rem"}}>
              <div style={{fontSize:".6rem",color:C.gris,marginBottom:".2rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>💬 Présentation affichée sur ta boutique</div>
              <textarea value={profil.boutiquePresentation||""} onChange={e=>setProfil(p=>({...p,boutiquePresentation:e.target.value}))} placeholder="Ex: Bienvenue dans ma boutique ! Retrouve ici tous mes produits Mihi preferes, choisis avec soin pour toi." rows={3}
                style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".8rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",resize:"vertical",lineHeight:1.55}}/>
            </div>

            <div style={{marginBottom:"1rem",padding:".75rem",background:C.creme,borderRadius:10,border:`1px solid ${C.pale}`}}>
              <label style={{display:"flex",alignItems:"center",gap:".6rem",cursor:"pointer"}}>
                <input type="checkbox" checked={!!profil.livraisonGratuite} onChange={e=>setProfil(p=>({...p,livraisonGratuite:e.target.checked}))}/>
                <span style={{fontSize:".74rem",color:C.brun,fontWeight:600}}>🚚 Offrir la livraison dès 60€ d'achat</span>
              </label>
              <div style={{fontSize:".65rem",color:C.gris,marginTop:".4rem",lineHeight:1.5}}>
                Les frais de livraison sont de 5,90€. Si tu actives cette option, ils seront automatiquement offerts pour toute commande de 60€ ou plus sur ta boutique.
              </div>
            </div>

            <div style={{marginBottom:".6rem"}}>
              <div style={{fontSize:".6rem",color:C.gris,marginBottom:".4rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>✨ Best-sellers à mettre en avant</div>
              <div style={{fontSize:".65rem",color:C.gris,marginBottom:".5rem",lineHeight:1.5}}>
                Choisis les produits qui apparaîtront en premier sur ta boutique, dans un onglet dédié "Best-sellers".
              </div>
              {!catalogueProduits?(
                <div style={{fontSize:".72rem",color:C.gris,padding:".5rem"}}>Chargement du catalogue...</div>
              ):(<>
                <input value={filtreBestSellers} onChange={e=>setFiltreBestSellers(e.target.value)} placeholder="🔍 Rechercher un produit..."
                  style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.creme,outline:"none",marginBottom:".5rem"}}/>
                <div style={{fontSize:".68rem",color:C.rose,fontWeight:700,marginBottom:".4rem"}}>{(profil.bestSellers||[]).length} sélectionné{(profil.bestSellers||[]).length>1?"s":""}</div>
                <div style={{maxHeight:280,overflowY:"auto",border:`1px solid ${C.pale}`,borderRadius:10}}>
                  {catalogueProduits.filter(p=>correspondRecherche(p.nom,filtreBestSellers)).slice(0,60).map(p=>{
                    const selectionne=(profil.bestSellers||[]).includes(p.ref);
                    return(
                      <label key={p.ref} style={{display:"flex",alignItems:"center",gap:".6rem",padding:".5rem .65rem",borderBottom:`1px solid ${C.pale}`,cursor:"pointer",background:selectionne?C.rose+"12":"transparent"}}>
                        <input type="checkbox" checked={selectionne} onChange={()=>{
                          setProfil(p2=>{
                            const arr=p2.bestSellers||[];
                            return {...p2,bestSellers:selectionne?arr.filter(r=>r!==p.ref):[...arr,p.ref]};
                          });
                        }}/>
                        <span style={{fontSize:".74rem",color:C.texte,flex:1}}>{p.nom}</span>
                        <span style={{fontSize:".68rem",color:C.gris,fontWeight:600}}>{p.prix?.toFixed?.(2)}€</span>
                      </label>
                    );
                  })}
                </div>
                {filtreBestSellers&&catalogueProduits.filter(p=>correspondRecherche(p.nom,filtreBestSellers)).length>60&&(
                  <div style={{fontSize:".65rem",color:C.gris,marginTop:".3rem"}}>Affinage la recherche pour voir plus de résultats (60 max affichés à la fois).</div>
                )}
              </>)}
            </div>

            <div style={{marginBottom:".6rem"}}>
              <div style={{fontSize:".6rem",color:C.gris,marginBottom:".4rem",fontWeight:600,textTransform:"uppercase",letterSpacing:".08em"}}>🎁 Mes packs personnalisés</div>
              <div style={{fontSize:".65rem",color:C.gris,marginBottom:".5rem",lineHeight:1.5}}>
                Crée tes propres bundles de produits à un prix spécial — ils apparaîtront dans un onglet dédié "Mes Packs" sur ta boutique.
              </div>
              {(profil.packsPersonnalises||[]).length>0&&(
                <div style={{marginBottom:".7rem"}}>
                  {(profil.packsPersonnalises||[]).map(pack=>(
                    <div key={pack.id} style={{background:C.creme,border:`1px solid ${C.pale}`,borderRadius:10,padding:".6rem .75rem",marginBottom:".4rem",display:"flex",justifyContent:"space-between",alignItems:"center",gap:".6rem"}}>
                      <div style={{display:"flex",alignItems:"center",gap:".6rem",flex:1,minWidth:0}}>
                        {pack.photos&&pack.photos.length>0&&(
                          <div style={{display:"flex",flexShrink:0}}>
                            {pack.photos.slice(0,3).map((img,i)=>(
                              <img key={i} src={img} alt="" style={{width:38,height:38,borderRadius:8,objectFit:"contain",background:"white",marginLeft:i>0?-14:0,border:"2px solid white",boxShadow:"0 1px 3px rgba(0,0,0,.15)"}}/>
                            ))}
                          </div>
                        )}
                        <div style={{minWidth:0}}>
                          <div style={{fontSize:".78rem",fontWeight:700,color:C.brun}}>{pack.nom}</div>
                          <div style={{fontSize:".65rem",color:C.gris}}>
                            {pack.produitsRefs.length} produit{pack.produitsRefs.length>1?"s":""} · {pack.prixPromo?(<><span style={{textDecoration:"line-through"}}>{pack.prix.toFixed(2)}€</span> <span style={{color:"#C44B1A",fontWeight:700}}>🏷️ {pack.prixPromo.toFixed(2)}€</span></>):(`${pack.prix.toFixed(2)}€`)}
                          </div>
                        </div>
                      </div>
                      <button onClick={()=>setProfil(p=>({...p,packsPersonnalises:(p.packsPersonnalises||[]).filter(pk=>pk.id!==pack.id)}))}
                        style={{background:"none",border:"none",color:"#C0504D",fontSize:".8rem",cursor:"pointer",flexShrink:0}}>🗑️</button>
                    </div>
                  ))}
                </div>
              )}
              {!creationPack?(
                <button onClick={()=>setCreationPack(true)}
                  style={{width:"100%",background:C.rose+"20",color:C.rose,border:`1.5px dashed ${C.rose}`,borderRadius:9,padding:".55rem",fontSize:".76rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                  + Créer un nouveau pack
                </button>
              ):(
                <div style={{background:C.creme,border:`1px solid ${C.pale}`,borderRadius:10,padding:".75rem"}}>
                  <input value={packNom} onChange={e=>setPackNom(e.target.value)} placeholder="Nom du pack (ex: Pack Détox Cheveux)"
                    style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none",marginBottom:".45rem"}}/>
                  {packPhotos.length>0&&(
                    <div style={{marginBottom:".5rem"}}>
                      <div style={{fontSize:".62rem",color:C.gris,marginBottom:".3rem"}}>Photos du pack (automatique, selon les produits cochés)</div>
                      <div style={{display:"flex",gap:".4rem",flexWrap:"wrap"}}>
                        {packPhotos.map((img,i)=>(
                          <img key={i} src={img} alt="" style={{width:50,height:50,borderRadius:8,objectFit:"contain",background:"white",border:`1px solid ${C.pale}`}}/>
                        ))}
                      </div>
                    </div>
                  )}
                  <input value={packPrix} onChange={e=>setPackPrix(e.target.value)} placeholder="Prix du pack en € (ex: 29.90)" type="number" step="0.01"
                    style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none",marginBottom:".45rem"}}/>
                  <label style={{display:"flex",alignItems:"center",gap:".5rem",marginBottom:".45rem",cursor:"pointer"}}>
                    <input type="checkbox" checked={packEnPromo} onChange={e=>{setPackEnPromo(e.target.checked);if(!e.target.checked)setPackPrixPromo("");}}/>
                    <span style={{fontSize:".74rem",color:C.texte,fontWeight:600}}>🏷️ Mettre ce pack en promotion</span>
                  </label>
                  {packEnPromo&&(
                    <input value={packPrixPromo} onChange={e=>setPackPrixPromo(e.target.value)} placeholder="Prix promo en € (ex: 24.90)" type="number" step="0.01"
                      style={{width:"100%",border:`1.5px solid #C44B1A`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:"#FFF3EC",outline:"none",marginBottom:".45rem"}}/>
                  )}
                  {!catalogueProduits?(
                    <div style={{fontSize:".72rem",color:C.gris,padding:".5rem"}}>Chargement du catalogue...</div>
                  ):(<>
                    <input value={filtrePack} onChange={e=>setFiltrePack(e.target.value)} placeholder="🔍 Rechercher un produit..."
                      style={{width:"100%",border:`1px solid ${C.pale}`,borderRadius:8,padding:".42rem .65rem",fontSize:".78rem",fontFamily:"inherit",color:C.texte,background:C.blanc,outline:"none",marginBottom:".4rem"}}/>
                    <div style={{fontSize:".66rem",color:C.rose,fontWeight:700,marginBottom:".3rem"}}>{packProduits.length} produit{packProduits.length>1?"s":""} sélectionné{packProduits.length>1?"s":""}</div>
                    <div style={{background:C.creme,borderRadius:8,padding:".5rem .7rem",marginBottom:".5rem",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span style={{fontSize:".7rem",color:C.gris}}>Total des produits sélectionnés (prix catalogue)</span>
                      <span style={{fontSize:".9rem",fontWeight:700,color:C.brun}}>
                        {packProduits.reduce((s,ref)=>{const prod=catalogueProduits.find(cp=>cp.ref===ref);return s+(prod?.prix||0);},0).toFixed(2)}€
                      </span>
                    </div>
                    <div style={{maxHeight:220,overflowY:"auto",border:`1px solid ${C.pale}`,borderRadius:9,marginBottom:".5rem"}}>
                      {catalogueProduits.filter(p=>correspondRecherche(p.nom,filtrePack)).slice(0,60).map(p=>{
                        const selectionne=packProduits.includes(p.ref);
                        return(
                          <label key={p.ref} style={{display:"flex",alignItems:"center",gap:".6rem",padding:".45rem .6rem",borderBottom:`1px solid ${C.pale}`,cursor:"pointer",background:selectionne?C.rose+"12":"transparent"}}>
                            <input type="checkbox" checked={selectionne} onChange={()=>{
                              const nouveauxRefs=selectionne?packProduits.filter(r=>r!==p.ref):[...packProduits,p.ref];
                              setPackProduits(nouveauxRefs);
                              const toutesImages=nouveauxRefs.map(ref=>catalogueProduits.find(cp=>cp.ref===ref)).filter(prod=>prod&&prod.image).map(prod=>prod.image);
                              setPackPhotos(toutesImages);
                            }}/>
                            <span style={{fontSize:".72rem",color:C.texte,flex:1}}>{p.nom}</span>
                            <span style={{fontSize:".66rem",color:C.gris,fontWeight:600}}>{p.prix?.toFixed?.(2)}€</span>
                          </label>
                        );
                      })}
                    </div>
                  </>)}
                  <div style={{display:"flex",gap:".4rem"}}>
                    <button onClick={()=>{
                        if(!packNom.trim()||!packPrix||packProduits.length===0)return;
                        const nouveauPack={id:"pack"+Date.now(),nom:packNom.trim(),prix:parseFloat(packPrix)||0,produitsRefs:[...packProduits],photos:packPhotos,
                          ...(packEnPromo&&packPrixPromo?{prixPromo:parseFloat(packPrixPromo)||0}:{})};
                        setProfil(p=>({...p,packsPersonnalises:[...(p.packsPersonnalises||[]),nouveauPack]}));
                        setPackNom("");setPackPrix("");setPackProduits([]);setFiltrePack("");setPackEnPromo(false);setPackPrixPromo("");setPackPhotos([]);setCreationPack(false);
                      }}
                      disabled={!packNom.trim()||!packPrix||packProduits.length===0}
                      style={{flex:1,background:(packNom.trim()&&packPrix&&packProduits.length>0)?C.brun:C.pale,color:(packNom.trim()&&packPrix&&packProduits.length>0)?C.blanc:C.gris,border:"none",borderRadius:8,padding:".5rem",fontSize:".76rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                      Créer ce pack
                    </button>
                    <button onClick={()=>{setCreationPack(false);setPackNom("");setPackPrix("");setPackProduits([]);setFiltrePack("");setPackEnPromo(false);setPackPrixPromo("");setPackPhotos([]);}}
                      style={{flex:1,background:C.blanc,color:C.gris,border:`1.5px solid ${C.pale}`,borderRadius:8,padding:".5rem",fontSize:".76rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer"}}>
                      Annuler
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* ── SECTION TOKENS CADEAUX (depliable) ────────────────── */}
            <div style={{marginTop:".8rem",marginBottom:".6rem"}}>
              <button onClick={()=>setTokensOuvert(o=>!o)}
                style={{width:"100%",background:tokensOuvert?"linear-gradient(135deg,#C4A962,#9E6B6B)":C.creme,border:`1.5px solid ${tokensOuvert?"transparent":C.or}`,borderRadius:12,padding:".7rem .85rem",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",fontFamily:"inherit",transition:"all .2s"}}>
                <span style={{display:"flex",alignItems:"center",gap:".5rem"}}>
                  <span style={{fontSize:"1.1rem"}}>🎁</span>
                  <span style={{fontSize:".78rem",fontWeight:700,color:tokensOuvert?"white":C.brun}}>Mes tokens cadeaux</span>
                </span>
                <span style={{fontSize:"1rem",color:tokensOuvert?"white":C.or,transform:tokensOuvert?"rotate(180deg)":"none",transition:"transform .2s"}}>⌄</span>
              </button>
              {!tokensOuvert&&(
                <div style={{fontSize:".65rem",color:C.gris,marginTop:".4rem",lineHeight:1.5,paddingLeft:".2rem"}}>
                  Offre des reductions exclusives a tes clientes. Chaque lien ne peut etre utilise qu'une seule fois — la popup s'affiche automatiquement sur ta boutique.
                </div>
              )}
              {tokensOuvert&&(
                <div style={{marginTop:".7rem",background:C.blanc,border:`1px solid ${C.pale}`,borderRadius:12,padding:".8rem"}}>
                  <TokensCadeauxTab uid={uid} db={db} prenom={userName}/>
                </div>
              )}
            </div>
          </>)}
        </div>
      )}

      {/* Bouton sauvegarder */}
      <div style={{marginTop:"1.2rem"}}>
        <button onClick={save} disabled={saving}
          style={{width:"100%",background:saved?C.vert:C.brun,color:C.blanc,border:"none",borderRadius:10,padding:".75rem",fontSize:".85rem",fontWeight:600,fontFamily:"inherit",cursor:"pointer",transition:"background .3s"}}>
          {saving?"Sauvegarde...":saved?"✅ Sauvegardé !":"Sauvegarder ma page"}
        </button>
      </div>
    </div>
  );
}

const GROUPES_STATS=[
  {titre:"Vue d'ensemble",champs:[
    {k:"visites",label:"Visites LinkBio",icon:"👁️"},
    {k:"boutique_visites",label:"Visites boutique",icon:"🛍️"},
  ]},
  {titre:"Tunnels de vente",champs:[
    {k:"tunnel_vente",label:"Découvrir les produits",icon:"🛒"},
    {k:"recrutement",label:"Rejoindre l'équipe",icon:"🤝"},
    {k:"tunnel_visites",label:"Visites du tunnel",icon:"🚪"},
  ]},
  {titre:"Diagnostics",champs:[
    {k:"clics_diag",label:"Total clics diagnostics",icon:"🔍"},
    {k:"diag_completes",label:"Diagnostics complétés",icon:"✅"},
  ]},
  {titre:"Boutique en ligne",champs:[
    {k:"boutique_ajout_panier",label:"Ajouts au panier",icon:"➕"},
    {k:"boutique_achat",label:"Achats confirmés",icon:"💳"},
  ]},
  {titre:"Liens & réseaux",champs:[
    {k:"clic_boutique_externe",label:"Lien boutique externe",icon:"🔗"},
    {k:"clic_recrutement_externe",label:"Lien recrutement externe",icon:"🔗"},
    {k:"clic_catalogue",label:"Catalogue produits",icon:"📖"},
    {k:"clic_boutique",label:"Ma boutique (bouton)",icon:"🛍️"},
    {k:"clic_lien_bonus",label:"Liens bonus",icon:"⭐"},
    {k:"clic_facebook",label:"Facebook",icon:"📘"},
    {k:"clic_instagram",label:"Instagram",icon:"📸"},
    {k:"clic_tiktok",label:"TikTok",icon:"🎵"},
    {k:"clic_youtube",label:"YouTube",icon:"▶️"},
  ]},
];

function dateKeyLocale(d){
  return d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0");
}

function valeurPourPeriode(stats,champ,periode){
  if(periode==="total") return stats[champ]||0;
  const nbJours=periode==="jour"?1:periode==="7j"?7:30;
  const parJour=stats.parJour||{};
  let total=0;
  const d=new Date();
  for(let i=0;i<nbJours;i++){
    const key=dateKeyLocale(d);
    total+=(parJour[key]&&parJour[key][champ])||0;
    d.setDate(d.getDate()-1);
  }
  return total;
}

function StatsLinkBio({uid}){
  const[stats,setStats]=React.useState(null);
  const[refresh,setRefresh]=React.useState(0);
  const[periode,setPeriode]=React.useState("total");
  React.useEffect(()=>{if(!uid)return;getDoc(doc(db,"linkbio_stats",uid)).then(s=>{if(s.exists())setStats(s.data());else setStats({});});},[uid,refresh]);
  if(!stats)return<div style={{textAlign:"center",padding:"2rem",color:"#888",fontSize:".78rem"}}>Chargement des stats...</div>;

  const PERIODES=[{id:"jour",label:"Aujourd'hui"},{id:"7j",label:"7 jours"},{id:"30j",label:"30 jours"},{id:"total",label:"Total"}];

  return(
    <div>
      <div style={{display:"flex",gap:".4rem",marginBottom:"1rem",overflowX:"auto"}}>
        {PERIODES.map(p=>(
          <button key={p.id} onClick={()=>setPeriode(p.id)}
            style={{flexShrink:0,background:periode===p.id?C.rose:"white",color:periode===p.id?"white":C.brun,border:`1.5px solid ${C.rose}`,borderRadius:20,padding:".4rem .9rem",fontSize:".7rem",fontWeight:700,fontFamily:"inherit",cursor:"pointer",whiteSpace:"nowrap"}}>
            {p.label}
          </button>
        ))}
      </div>

      {GROUPES_STATS.map(groupe=>{
        const champsAvecValeur=groupe.champs.filter(c=>valeurPourPeriode(stats,c.k,periode)>0||periode==="total");
        if(champsAvecValeur.length===0)return null;
        return(
          <div key={groupe.titre} style={{marginBottom:"1.1rem"}}>
            <div style={{fontSize:".62rem",fontWeight:700,color:C.gris,textTransform:"uppercase",letterSpacing:".08em",marginBottom:".4rem"}}>{groupe.titre}</div>
            <div style={{display:"flex",flexDirection:"column",gap:".5rem"}}>
              {champsAvecValeur.map(c=>(
                <div key={c.k} style={{background:"white",border:"1px solid #eee",borderRadius:12,padding:".75rem .9rem",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{fontSize:".76rem",color:C.brun,fontWeight:600}}>{c.label}</div>
                  <div style={{display:"flex",alignItems:"center",gap:".5rem"}}>
                    <div style={{fontSize:"1.15rem",fontWeight:700,color:"#5C3D2E"}}>{valeurPourPeriode(stats,c.k,periode)}</div>
                    <div>{c.icon}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
function EbooksLinkBioSection({profil,setProfil}){
  const THEMES_EBOOKS=[
    {id:"skincare",label:"✨ Skincare / Visage"},
    {id:"cheveux",label:"💇 Soin cheveux"},
    {id:"silhouette",label:"⚖️ Silhouette / Perte de poids"},
    {id:"recettes",label:"🍽️ Recettes minceur"},
    {id:"energie",label:"⚡ Énergie, sommeil, stress"},
    {id:"parfums",label:"🌸 Parfums"},
    {id:"makeup",label:"💄 Make-up"},
    {id:"bienetre",label:"🧘 Bien-être général"},
    {id:"recrutement",label:"🤝 Opportunité / Recrutement"},
  ];
  const[ebooks,setEbooks]=useState([]);
  const[loading,setLoading]=useState(true);
  const selected=profil.ebooksIds||[];
  useEffect(()=>{
    (async()=>{
      try{
        const snap=await getDoc(doc(db,"admin","ebooks"));
        if(snap.exists()) setEbooks((snap.data().items||[]).filter(e=>e.actif!==false));
      }catch{}
      setLoading(false);
    })();
  },[]);
  const toggle=(id)=>{
    const cur=profil.ebooksIds||[];
    setProfil(p=>({...p,ebooksIds:cur.includes(id)?cur.filter(x=>x!==id):[...cur,id]}));
  };
  if(loading) return <div style={{color:C.gris,fontSize:".75rem",padding:".5rem"}}>Chargement des ebooks...</div>;
  if(ebooks.length===0) return(
    <div style={{textAlign:"center",padding:"1.5rem",color:C.gris,fontSize:".75rem"}}>
      <div style={{fontSize:"1.5rem",marginBottom:".5rem"}}>📚</div>
      Aucun ebook disponible.<br/>Melissa doit d'abord en créer depuis l'Espace Admin.
    </div>
  );
  const parTheme=THEMES_EBOOKS.map(t=>({
    ...t,
    items:ebooks.filter(e=>(e.themes||[]).includes(t.id))
  })).filter(t=>t.items.length>0);
  return(
    <div>
      <div style={{fontSize:".6rem",fontWeight:700,color:C.gris,letterSpacing:".1em",textTransform:"uppercase",marginBottom:".4rem"}}>Ebooks à proposer dans ton tunnel</div>
      <p style={{fontSize:".7rem",color:C.gris,marginBottom:".85rem",lineHeight:1.6}}>
        Choisis les ebooks que tes clientes verront après avoir laissé leurs coordonnées. Tu peux en sélectionner plusieurs.
      </p>
      {parTheme.map(t=>(
        <div key={t.id} style={{marginBottom:".85rem"}}>
          <div style={{fontSize:".62rem",fontWeight:700,color:C.rose,textTransform:"uppercase",letterSpacing:".08em",marginBottom:".35rem"}}>{t.label}</div>
          {t.items.map(eb=>{
            const sel=selected.includes(eb.id);
            return(
              <div key={eb.id} onClick={()=>toggle(eb.id)}
                style={{display:"flex",alignItems:"center",gap:".65rem",background:sel?C.rose+"12":C.creme,borderRadius:10,padding:".55rem .75rem",marginBottom:".3rem",border:`1.5px solid ${sel?C.rose:C.pale}`,cursor:"pointer",transition:"all .15s"}}>
                {eb.imageCover&&<img src={eb.imageCover} alt="" style={{width:32,height:44,objectFit:"cover",borderRadius:5,flexShrink:0}}/>}
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:".78rem",fontWeight:600,color:C.brun,marginBottom:".1rem"}}>{eb.titre}</div>
                  {eb.description&&<div style={{fontSize:".62rem",color:C.gris,lineHeight:1.4}}>{eb.description}</div>}
                </div>
                <div style={{width:20,height:20,borderRadius:"50%",border:`2px solid ${sel?C.rose:C.pale}`,background:sel?C.rose:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  {sel&&<div style={{width:8,height:8,borderRadius:"50%",background:"white"}}/>}
                </div>
              </div>
            );
          })}
        </div>
      ))}
      {selected.length>0&&(
        <div style={{background:C.rose+"15",border:`1px solid ${C.rose}30`,borderRadius:8,padding:".5rem .75rem",fontSize:".68rem",color:C.rose,fontWeight:600,marginTop:".25rem"}}>
          ✅ {selected.length} ebook{selected.length>1?"s":""} sélectionné{selected.length>1?"s":""}
        </div>
      )}
    </div>
  );
}
export { LinkBioTab };
